import { css } from '@emotion/css';

export const animatedGradientText = css`
  background: linear-gradient(135deg, #1f0a43, #8663e8, #1f0a43);
  background-size: 300% 300%;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;

  animation: textGradientMove 4s ease-in-out infinite;

  @keyframes textGradientMove {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

export { gradientBorderClass } from 'components/AiGradientButton';

export const gradiantBackground = css`
  background: radial-gradient(
    circle at 60% 5%,
    rgba(160, 35, 255, 0.25),
    rgba(159, 125, 237, 0.25) 50%,
    rgba(249, 140, 146, 0.15) 100%,
    transparent 65%
  );
`;

export const blackMarkdownText = css`
  * {
    color: black;
  }
  p {
    margin-bottom: var(--mantine-spacing-xs);
  }
`;

export const skeletonLoadingText = css`
  background: linear-gradient(
    90deg,
    var(--mantine-color-gray-5) 0%,
    var(--mantine-color-gray-6) 50%,
    var(--mantine-color-gray-5) 100%
  );
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  animation: textSkeletonMove 1.5s ease-in-out infinite;

  @keyframes textSkeletonMove {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
